<template>
	<div class="ui top fixed menu">
		<router-link class="icon item" :to="{name : 'home'}" >
			<img :src="`${cdnUrl()}/product-experience/logo_rdp.png`" />
		</router-link>
		<a id="menu" class="icon item">
			<i class="sidebar icon"></i>
		</a>

		<div class="right floated menu">
			<router-link class="item" :to="{ name: 'logout' }">Logout</router-link>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Navbar',
	methods: {
		cdnUrl() {
			return process.env.VUE_APP_RDP_CDN;
		},
	}
};
</script>

<style scoped>
.ui.menu {
	background: rgba(144, 142, 142, 0.75);
	box-shadow: 0 2px 2px 0 rgba(204,0,0,.15);
}
.ui.menu a {
	color: rgb(255,255,255);

}

</style>
